import { getFullUrl } from './getFullUrl';
import { getSmallestSize } from './getSmallestSize';
import { getSrcWithParams } from './getSrcWithParams';
export function getLQIP(sizes, widths, baseUrl, aspect) {
    const smallestImage = sizes && getFullUrl(getSmallestSize(sizes), baseUrl);
    const transparent = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    if (!smallestImage)
        return transparent;
    const smallestWidth = widths.sort((a, b) => a - b)[0];
    const srcset = getSrcWithParams(smallestWidth, aspect, smallestImage, false, {
        crop: false
    }) + '&sigma=2.5&minampl=0.5';
    return srcset;
}
//# sourceMappingURL=getLQIP.js.map